/**
 * @generated SignedSource<<7e0c49af1533b806d633d2999cda1596>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type useMeetingRecordingWebsocketRegenerateFeedbackMutation$variables = {
  meetingRecordingId: string;
};
export type useMeetingRecordingWebsocketRegenerateFeedbackMutation$data = {
  readonly regenerateSummary: {
    readonly ok: boolean;
  } | null;
};
export type useMeetingRecordingWebsocketRegenerateFeedbackMutation = {
  response: useMeetingRecordingWebsocketRegenerateFeedbackMutation$data;
  variables: useMeetingRecordingWebsocketRegenerateFeedbackMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "meetingRecordingId"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "meetingRecordingId",
        "variableName": "meetingRecordingId"
      }
    ],
    "concreteType": "RegenerateSummary",
    "kind": "LinkedField",
    "name": "regenerateSummary",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "ok",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useMeetingRecordingWebsocketRegenerateFeedbackMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useMeetingRecordingWebsocketRegenerateFeedbackMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "999e734096f059f206a31513e76d85d6",
    "id": null,
    "metadata": {},
    "name": "useMeetingRecordingWebsocketRegenerateFeedbackMutation",
    "operationKind": "mutation",
    "text": "mutation useMeetingRecordingWebsocketRegenerateFeedbackMutation(\n  $meetingRecordingId: ID!\n) {\n  regenerateSummary(meetingRecordingId: $meetingRecordingId) {\n    ok\n  }\n}\n"
  }
};
})();

(node as any).hash = "82027bcf3328c21700c40b43471e15b2";

export default node;
